import {type ClassValue, clsx} from "clsx";
import {twMerge} from "tailwind-merge";
import {format} from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats an ISO date string to 'yyyy-MM-dd HH:mm'. Returns '-' if invalid.
 */
// export function formatDate(date: string | Date): string {
//   try {
//     return format(new Date(date), "yyyy-MM-dd HH:mm");
//   } catch {
//     return "-";
//   }
// }

// Format date for display
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return (
    date.toLocaleDateString() +
    " " +
    date.toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"})
  );
};
